import apiService from "./apiService";
import AppConstants from "../appConstants";

class AcronymsService {
    getAllAcronyms(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ACRONYMS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getAcronymsByOriginAndName(params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_ACRONYMS_DETAIL_NAME}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getAcronymsDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_ACRONYMS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerAcronyms(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ACRONYMS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteAcronyms(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_ACRONYMS}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_ACRONYMS_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new AcronymsService();
